import { render, staticRenderFns } from "./LiveLocation.vue?vue&type=template&id=2c259c87"
import script from "./LiveLocation.vue?vue&type=script&lang=js"
export * from "./LiveLocation.vue?vue&type=script&lang=js"
import style0 from "./LiveLocation.vue?vue&type=style&index=0&id=2c259c87&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage});
